module.exports = __webpack_public_path__ + "static/img/img_p3_3_pic.435e425.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_p3_3_pic.png
// module id = d0j/
// module chunks = 1